import React from 'react';
import Typography from 'kingpin/atoms/Typography';

import Modal from './Modal';
import Button from '../../../../kingpin/atoms/Button';

const ChangePassword = ({
  isOpen,
  open,
  close,
  onSubmit,
  onCancel,
  hasWrongPassword,
  isLoading,
  currentPassword,
  onCurrentPasswordChanged,
  newPassword,
  onNewPasswordChanged,
  newPasswordErrors,
  isHidingPassword,
  setIsHidingPassword,
  isValid,
}: {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  hasWrongPassword: boolean;
  isLoading: boolean;
  currentPassword: string;
  onCurrentPasswordChanged: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  newPassword: string;
  onNewPasswordChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
  newPasswordErrors: string[] | undefined;
  isHidingPassword: boolean;
  setIsHidingPassword: React.Dispatch<React.SetStateAction<boolean>>;
  isValid: boolean;
}) => (
  <React.Fragment>
    <div style={{ marginBottom: 24 }}>
      <Typography.Header type="H5">Password</Typography.Header>
    </div>
    <Button
      onClick={isOpen ? close : open}
      testId="change-password"
      label="Change Password"
      size="Small"
      type="Secondary"
    />
    {isOpen && (
      <Modal
        isOpen={isOpen}
        close={close}
        onSubmit={onSubmit}
        onCancel={onCancel}
        hasWrongPassword={hasWrongPassword}
        isLoading={isLoading}
        currentPassword={currentPassword}
        onCurrentPasswordChanged={onCurrentPasswordChanged}
        newPassword={newPassword}
        onNewPasswordChanged={onNewPasswordChanged}
        newPasswordErrors={newPasswordErrors}
        isHidingPassword={isHidingPassword}
        setIsHidingPassword={setIsHidingPassword}
        isValid={isValid}
      />
    )}
  </React.Fragment>
);

export default ChangePassword;
